import { createApp } from '@app/adapters/create-app'

import Carousel from '@app/shared/vue/components/sf-carousel/sf-carousel-navigation.vue'

export default (): void => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const container = doc.querySelector(
      '[data-behaviour="navigation-carousel"]'
    ) as HTMLElement

    if (container) {
      createApp(Carousel, {
        previousAction: container.dataset.previousAction,
        nextAction: container.dataset.nextAction,
      }).mount(container)
    }
  })
}
